import _defineProperty from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import Default from "./Default";
import Csp from "./Csp";
import StartPage from "./StartPage";
function layoutCreator(Layout) {
  return function withLayout(Component) {
    var layoutProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var NewComponent = function NewComponent(props) {
      return /*#__PURE__*/React.createElement(Component, props);
    };
    NewComponent.getLayout = function (page) {
      return /*#__PURE__*/React.createElement(Layout, _objectSpread({
        title: Component.title,
        isPublic: Component.isPublic
      }, layoutProps), page);
    };
    NewComponent.isPublic = Component.isPublic;
    return NewComponent;
  };
}
export var withLayout = layoutCreator(Default);
export var withLayoutCSP = layoutCreator(Csp);
export var withLayoutStartPage = layoutCreator(StartPage);
export default withLayout;